export class FundDescription {
  public id: number;
  public name: string;
  public frequency_alias: string;
  public is_private: boolean;
  public inception_date: Date;
  public last_date: Date;
  
  constructor(data: any) {
      this.id               = data.id;
      this.name             = data.name;
      this.frequency_alias  = data.frequency_alias;
      this.is_private       = data.is_private;
      this.inception_date   = new Date(data.inception_date);
      this.last_date        = new Date(data.last_date);
  }

}
